import React from "react";
import {
  Card as StyledCard,
  CardHeader,
  CardHeaderLeft,
  CardTitle,
  IconContainer,
} from "../styles";
import Icon from "./Icon";

const Card = ({ title, icon, right, children }) => {
  return (
    <StyledCard>
      <CardHeader>
        <CardHeaderLeft>
          {icon && (
            <IconContainer>
              <Icon name={icon} />
            </IconContainer>
          )}
          <CardTitle>{title}</CardTitle>
        </CardHeaderLeft>
        {right}
      </CardHeader>
      {children}
    </StyledCard>
  );
};

export default Card;
